<template>
  <div v-loading="loading">
    <div id="wrap">
      <div class="header flex flex-justify">
        <div>专精特新立项</div>
        <!--        <div class="flex">
          <div style="margin-right: 10px">
            <el-radio-group v-model="tab">
              <span @click="cur = 0"
                ><el-radio-button label="全部"></el-radio-button
              ></span>
&lt;!&ndash;              <span @click="cur = 1">
                <el-radio-button label="进行中"></el-radio-button
              ></span>
              <span @click="cur = 2"
                ><el-radio-button label="已完成"></el-radio-button
              ></span>&ndash;&gt;
            </el-radio-group>
          </div>
          <el-input style="width: 200px;margin-right:10px;" placeholder="请输入" v-model="queryParams.keyword"
            ><i slot="prefix" class="el-input__icon el-icon-search"></i
          ></el-input>
          <el-button type="primary">查询</el-button>
        </div> -->
      </div>
    </div>

    <div id="wrap2" class="wrap_page" style="margin-top: 20px">
      <div style="margin-bottom: 10px; margin-top: 10px" class="flex flex-end">
        <el-button @click="pagefn" type="primary">新增</el-button>
      </div>
      <div v-show="cur == 0">
        <div>
          <el-table
            class="table"
            v-loading="loading"
            :data="projects"
            :header-cell-style="{ background: '#F5F7FA' }"
            stripe
            :row-class-name="tableRowClassName"
          >
            <el-table-column label="序号" width="60" prop="index">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="zjtxType"
              label="类型"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="公司名称"
              show-overflow-tooltip
              prop="companyName"
            ></el-table-column>
            <el-table-column
              label="年份"
              show-overflow-tooltip
              prop="createTime"
              :formatter="formatForYear"
            ></el-table-column>
            <el-table-column
              label="创建人"
              show-overflow-tooltip
              prop="createBy"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.createBy == null || scope.row.createBy == ""
                    ? "--"
                    : scope.row.createBy
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="完成度" prop="integrity">
              <template slot-scope="scope">
                <span>{{ Number(scope.row.integrity) * 20 }}%</span>
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
              width="120"
              prop="materialGenerateState"
            >
              <template slot-scope="scope">
                <span>{{ status[scope.row.materialGenerateState] }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140">
              <template slot-scope="scope">
                <!--                <router-link :to="{path:'/specialization/registration',query:{id:scope.row.id}}">-->
                <el-button
                  type="text"
                  size="small"
                  class="green"
                  @click="edit(scope.row.id)"
                  >编辑</el-button
                >
                <!--                </router-link>-->
                <el-button
                  type="text"
                  size="small"
                  class="red"
                  @click="deleteFn(scope.row.id)"
                  >删除</el-button
                >
                <el-button
                  v-loading="downloadLoading"
                  type="text"
                  v-if="scope.row.materialGenerateState == 1"
                  @click="download(scope.row.materialGenerateUrl)"
                  size="small"
                  class="blue"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="flex flex-end">
            <el-pagination
              background
              v-show="total > 0"
              :total="total"
              :current-page.sync="queryParams.pageNum"
              :page-size.sync="queryParams.pageSize"
              @current-change="queryData"
            >
            </el-pagination>
          </div>
          <!-- ----- -->
          <!--          <div class="item">
&lt;!&ndash;            <div class="logo">Task</div>
            <div class="item_txt">
              <div>项目类型：{{item.zjtxType}}</div>
              <div class="p">公司名称：{{item.companyName}}</div>
            </div>
            <div class="item_txt">
              <div class="p">年份</div>
              <div class="p">2021</div>
            </div>
            <div class="item_txt">
              <div class="p">批次</div>
              <div class="p">2</div>
            </div>
            <div class="item_txt">
              <div class="p">创建时间</div>
              <div class="p">2021-05-10</div>
            </div>
            <div class="item_txt">
              <div class="p">创建人</div>
              <div class="p">何永浩</div>
            </div>&ndash;&gt;
            <div class="item_txt">
              <div>
                <el-progress
                  :percentage="50"
                  :color="customColor"
                ></el-progress>
              </div>
            </div>
            <div class="item_txt">
              <div>
                <el-link type="primary" class="compile">编辑</el-link>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="deleteFn(1)">删除</el-dropdown-item>
                    <el-dropdown-item>下载</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>-->
          <!-- --------- -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { zuan_delete, Querylist, queryBaseInfo } from "./index";
import { commonFileGetFileByUrl } from "./ChinaHigh";
export default {
  data() {
    return {
      downloadLoading: false,
      total: 0,
      queryParams: {
        keyword: "",
        pageNum: 1,
        pageSize: 10,
      },
      tab: "全部",
      cur: 0,
      // percentage: 50,
      customColor: "#4988df",
      projects: [],
      loading: false,
      status: ["未完成", "完成", "生成中", "生成失败"],
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    formatForYear(row, column) {
      // console.log(row);
      // let dt=new Date(data);
      // return dt.getFullYear();
      return new Date(row.createTime).getFullYear();
    },
    edit(id) {
      sessionStorage.setItem("zt_special_id", id);
      this.$router.push({ path: "/centerform/specializationRegistration" });
    },
    queryData() {
      this.loading = true;
      Querylist(this.queryParams).then((res) => {
        this.projects = res.data.records;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "background:#fff";
      } else {
        return "background:#F5F7FA";
      }
    },
    pagefn: function () {
      sessionStorage.setItem("zt_special_id", 0);
      this.$router.push({ path: "/centerform/specializationRegistration" });
    },

    deleteFn(id) {
      this.$confirm("是否确认删除项目?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return zuan_delete(id);
        })
        .then((res) => {
          if (res.code == "00000") {
            this.msgSuccess("删除成功");
            this.queryData();
          }
        });
    },
    download(path) {
      this.downloadLoading = true;
      commonFileGetFileByUrl({ url: path }).then((res) => {
        this.downloadLoading = false;
        window.open(res.data, "_blank");
      });
    },
  },
};
</script>

<style scoped>
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #dbdbdb;
  padding: 10px;
}
.item .logo {
  width: 48px;
  height: 48px;
  text-align: center;
  line-height: 48px;
  border-radius: 4px;
  font-size: 15px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(89, 126, 247, 1);
}
.item .item_txt {
  flex-wrap: wrap;
  align-items: center;
  line-height: 20px;
  font-size: 14px;
}
.item .item_txt .p {
  color: rgba(0, 0, 0, 0.45);
}
.el-progress {
  width: 150px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #4988df;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.compile {
  margin-right: 10px;
}
</style>
